<div class="xvi-icons-renderer">
  <ng-container *ngFor="let config of value">
    <xux-tooltip-icon
    *ngIf="config"
    [config]="config"
    ></xux-tooltip-icon>
  </ng-container>
</div>
